import { Typography } from '@mui/material';
import Box from '@mui/material/Box';
import { GenerationModelDetails } from '~/domain/dicom/dicomBase';

type ModelDetailsProps = {
    generationModel?: GenerationModelDetails;
};

export default function ModelDetails({ generationModel }: ModelDetailsProps) {
    if (!generationModel?.label) {
        return null;
    }

    return (
        <Box
            display="grid"
            gridTemplateColumns="1fr auto"
            justifyContent={'space-between'}
            gap={0.5}
            alignItems="start"
        >
            <Typography
                fontSize={12}
                variant="body2"
                sx={{
                    whiteSpace: 'nowrap',
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                }}
            >
                {generationModel.label || generationModel.name}
            </Typography>
            {generationModel.version && (
                <Typography
                    fontSize={12}
                    variant="body2"
                    sx={{
                        whiteSpace: 'nowrap',
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                    }}
                >
                    v. {generationModel.version}
                </Typography>
            )}
        </Box>
    );
}
